import axios from "axios";

/**
 * Extract a user-friendly error message from an Axios error response.
 * The backend returns errors in the format:
 *   { statusCode, message: string | string[], error?: string }
 */
export const getErrorMessage = (error) => {
    if (axios.isAxiosError(error) && error.response?.data) {
        const apiError = error.response.data;
        if (Array.isArray(apiError.message)) {
            return apiError.message[0];
        }
        return apiError.message || "An unexpected error occurred";
    }
    if (error instanceof Error) {
        return error.message;
    }
    return "Network error. Please try again.";
};
